"use strict";
var __webpack_modules__ = {
    "./domain-id/domain-id.service": function(module) {
        module.exports = require("./domain-id/domain-id.service.js");
    },
    "./jwt": function(module) {
        module.exports = require("./jwt/index.js");
    },
    "./strategy-fetch/constants": function(module) {
        module.exports = require("./strategy-fetch/constants.js");
    },
    "./strategy-fetch/network-first": function(module) {
        module.exports = require("./strategy-fetch/network-first.js");
    },
    "./strategy-fetch/stale-while-revalidate": function(module) {
        module.exports = require("./strategy-fetch/stale-while-revalidate.js");
    },
    "./tcc-proxy?4aeb": function(module) {
        module.exports = require("./tcc-proxy/index.js");
    },
    "./util/ls": function(module) {
        module.exports = require("./util/ls.js");
    },
    eventemitter3: function(module) {
        module.exports = require("eventemitter3");
    }
};
var __webpack_module_cache__ = {};
function __webpack_require__(moduleId) {
    var cachedModule = __webpack_module_cache__[moduleId];
    if (void 0 !== cachedModule) return cachedModule.exports;
    var module = __webpack_module_cache__[moduleId] = {
        exports: {}
    };
    __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
    return module.exports;
}
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
(()=>{
    __webpack_require__.r(__webpack_exports__);
    __webpack_require__.d(__webpack_exports__, {
        BaseDomainIDService: ()=>_domain_id_domain_id_service__WEBPACK_IMPORTED_MODULE_0__.BaseDomainIDService,
        EventEmitter: ()=>eventemitter3__WEBPACK_IMPORTED_MODULE_4__.EventEmitter,
        FETCH_STRATEGY_RESPONSE_SOURCE_HEADER_NAME: ()=>_strategy_fetch_constants__WEBPACK_IMPORTED_MODULE_5__.FETCH_STRATEGY_RESPONSE_SOURCE_HEADER_NAME,
        FetchStrategyResponseSourceHeaderValue: ()=>_strategy_fetch_constants__WEBPACK_IMPORTED_MODULE_5__.FetchStrategyResponseSourceHeaderValue,
        ls: ()=>_util_ls__WEBPACK_IMPORTED_MODULE_1__.ls,
        networkFirstFetch: ()=>_strategy_fetch_network_first__WEBPACK_IMPORTED_MODULE_6__.networkFirstFetch,
        staleWhileRevalidateFetch: ()=>_strategy_fetch_stale_while_revalidate__WEBPACK_IMPORTED_MODULE_7__.staleWhileRevalidateFetch
    });
    var _domain_id_domain_id_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./domain-id/domain-id.service");
    var _util_ls__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./util/ls");
    var _jwt__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./jwt");
    var __WEBPACK_REEXPORT_OBJECT__ = {};
    for(var __WEBPACK_IMPORT_KEY__ in _jwt__WEBPACK_IMPORTED_MODULE_2__)if ([
        "BaseDomainIDService",
        "staleWhileRevalidateFetch",
        "networkFirstFetch",
        "default",
        "FetchStrategyResponseSourceHeaderValue",
        "ls",
        "FETCH_STRATEGY_RESPONSE_SOURCE_HEADER_NAME",
        "EventEmitter"
    ].indexOf(__WEBPACK_IMPORT_KEY__) < 0) __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = (function(key) {
        return _jwt__WEBPACK_IMPORTED_MODULE_2__[key];
    }).bind(0, __WEBPACK_IMPORT_KEY__);
    __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
    var _tcc_proxy__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./tcc-proxy?4aeb");
    var __WEBPACK_REEXPORT_OBJECT__ = {};
    for(var __WEBPACK_IMPORT_KEY__ in _tcc_proxy__WEBPACK_IMPORTED_MODULE_3__)if ([
        "BaseDomainIDService",
        "staleWhileRevalidateFetch",
        "networkFirstFetch",
        "default",
        "FetchStrategyResponseSourceHeaderValue",
        "ls",
        "FETCH_STRATEGY_RESPONSE_SOURCE_HEADER_NAME",
        "EventEmitter"
    ].indexOf(__WEBPACK_IMPORT_KEY__) < 0) __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = (function(key) {
        return _tcc_proxy__WEBPACK_IMPORTED_MODULE_3__[key];
    }).bind(0, __WEBPACK_IMPORT_KEY__);
    __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
    var eventemitter3__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("eventemitter3");
    var _strategy_fetch_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./strategy-fetch/constants");
    var _strategy_fetch_network_first__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./strategy-fetch/network-first");
    var _strategy_fetch_stale_while_revalidate__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./strategy-fetch/stale-while-revalidate");
})();
exports.BaseDomainIDService = __webpack_exports__.BaseDomainIDService;
exports.EventEmitter = __webpack_exports__.EventEmitter;
exports.FETCH_STRATEGY_RESPONSE_SOURCE_HEADER_NAME = __webpack_exports__.FETCH_STRATEGY_RESPONSE_SOURCE_HEADER_NAME;
exports.FetchStrategyResponseSourceHeaderValue = __webpack_exports__.FetchStrategyResponseSourceHeaderValue;
exports.ls = __webpack_exports__.ls;
exports.networkFirstFetch = __webpack_exports__.networkFirstFetch;
exports.staleWhileRevalidateFetch = __webpack_exports__.staleWhileRevalidateFetch;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "BaseDomainIDService",
    "EventEmitter",
    "FETCH_STRATEGY_RESPONSE_SOURCE_HEADER_NAME",
    "FetchStrategyResponseSourceHeaderValue",
    "ls",
    "networkFirstFetch",
    "staleWhileRevalidateFetch"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
